import React from 'react';
import type { CurationState, CurationKey } from './useCurationFilter';

interface Props {
  curation: CurationState;
  onToggle: (key: CurationKey) => void;
  theme: 'dark' | 'light';
}

const FILTERS: [CurationKey, string][] = [
  ['all',      'All'],
  ['frequent', 'Frequent'],
  ['favorite', 'Favorites'],
  ['topRated', 'Top'],
];

export const CurationFilter: React.FC<Props> = ({ curation, onToggle, theme }) => (
  <div style={{
    padding: '4px 8px 6px',
    borderBottom: `1px solid ${theme === 'dark' ? 'rgba(255,255,255,0.07)' : '#e5e7eb'}`,
    flexShrink: 0,
    display: 'flex',
    flexWrap: 'wrap',
    gap: '2px 10px',
  }}>
    {FILTERS.map(([key, label]) => {
      const checked = curation[key];
      return (
        <label
          key={key}
          style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer', userSelect: 'none' }}
        >
          <input
            type="checkbox"
            checked={checked}
            onChange={() => onToggle(key)}
            style={{ accentColor: '#309B48', width: '11px', height: '11px', cursor: 'pointer' }}
          />
          <span style={{
            fontSize: '10px',
            fontWeight: checked ? 600 : 400,
            color: checked
              ? (theme === 'dark' ? '#86efac' : '#166534')
              : (theme === 'dark' ? 'rgba(255,255,255,0.5)' : '#6b7280'),
          }}>
            {label}
          </span>
        </label>
      );
    })}
  </div>
);
